export default __webpack_public_path__ + "static/media/jquery-icon1.aab90816.png";